var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcaStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1856,
    height: 820,
    viewBox: "0 0 1856 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BCA_NEW"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BCA_NEW",
    "data-name": "BCA NEW",
    clipPath: "url(#clip-BCA_NEW)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1856,
    height: 820
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yard_Layout",
    "data-name": "Yard Layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stationinfo",
    transform: "translate(-4332.808 30)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "StationInfoenglish",
    transform: "translate(5215.654 22)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\u092C\u091B\u0935\u093E\u0930\u093E\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(5170.808 39.216)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "StationInfo-2",
    "data-name": "StationInfo",
    transform: "translate(5181.142 80.431)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tBACHWARA\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo",
    transform: "translate(45 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(35.597 0.608) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M50.9,50.9,1.888,49.625.608.608l49.017,1.28Z",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.121,1.121,2.375,49.137l48.016,1.254L49.137,2.375,1.121,1.121M.094.094,50.112,1.4l1.306,50.018L1.4,50.112Z",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.204 19.74)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 17.799,
    ry: 18.753,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 15.299,
    ry: 16.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M.568-1.031h0s8.95,7.449,10.283,9.924a47.609,47.609,0,0,1,2.316,5.086",
    transform: "translate(9.332 30.117)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(16.001 22.307) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M.143,5.135.455.013l14.3.812,2.286,4.348L15.152,5.2Z",
    transform: "translate(0.54 0.509)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1.448,1.027,1.2,5.165l14.469.058L16.8,5.209,15,1.8,1.448,1.027M.542.015,15.58.869l2.778,5.284-2.639.033L.171,6.123Z",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 7.56, 30.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.893.459-.014.5,0,0,3.893.366Z",
    transform: "translate(0.473 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.013,0,4.85.455v1l-4.892.051Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44,44",
    transform: "translate(-3.719 31.506)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 1.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 31.584)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 26.649)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(9.368 21.714)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(69.789) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(70.258 73.532) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 27.636)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(8.431 22.701)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-3",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(34.192 37.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-4",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-4",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-4",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TC203T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_203T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC203TLine",
    d: "M.446,3.7,4.692,0H68",
    transform: "translate(470.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_203TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC203TLabel",
    transform: "translate(484.523 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_203TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t203T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC59_60T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_59/60T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC59_60TLine",
    x2: 77,
    transform: "translate(541.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_59/60TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC59_60TLabel",
    transform: "translate(562.359 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_59/60TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t59/60T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC09T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_09T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC09T1Line",
    x2: 170,
    transform: "translate(737.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_09T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC09T1Label",
    transform: "translate(812.523 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_09T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t09T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC09T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_09T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC09TLine",
    x2: 166,
    transform: "translate(910.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_09TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC09TLabel",
    transform: "translate(985.668 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_09TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t09T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC9T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_9T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC9TLine",
    x2: 128,
    transform: "translate(1079.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_9TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC9TLabel",
    transform: "translate(1134.812 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_9TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t9T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC72BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_72BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC72BTLine",
    x2: 200,
    transform: "translate(1210.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_72BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC72BTLabel",
    transform: "translate(1293.104 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_72BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t72BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC015T",
    transform: "translate(2)",
    className: "tooltip",
    "edge-id": "BCA_TRACK_015T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC015TLine",
    x2: 169,
    transform: "translate(1413.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_015TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC015TLabel",
    transform: "translate(1485.523 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_015TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t015T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC07T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_07T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC07T2Line",
    x2: 133,
    transform: "translate(601.5 282.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_07T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC07T2Label",
    transform: "translate(655.523 278)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_07T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t07T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC07T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_07T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC07T1Line",
    x2: 170,
    transform: "translate(737.5 282.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_07T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC07T1Label",
    transform: "translate(803.523 278)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_07T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t07T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC07T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_07T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC07TLine",
    x2: 166,
    transform: "translate(910.5 282.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_07TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC07TLabel",
    transform: "translate(984.668 278)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_07TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t07T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC7T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_7T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC7TLine",
    x2: 83,
    transform: "translate(1079.5 282.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_7TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC7TLabel",
    transform: "translate(1118.812 294)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_7TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t7T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC12T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_12T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC12TLine",
    x2: 108,
    transform: "translate(447.5 343.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_12TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC12TLabel",
    transform: "translate(489.668 340)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_12TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t12T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC012T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_012T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC012TLine",
    x2: 176,
    transform: "translate(558.5 343.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_012TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC012TLabel",
    transform: "translate(635.523 340)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_012TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t012T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC012T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_012T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC012T1Line",
    x2: 173,
    transform: "translate(737.5 343.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_012T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC012T1Laebl",
    transform: "translate(821.378 339)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_012T1TLaebl"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t012T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC012T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_012T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC012T2Line",
    x2: 186,
    transform: "translate(913.5 343.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_012T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC012T2Label",
    transform: "translate(991.378 339)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_012T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t012T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC54AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_54AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC54ATLine",
    x2: 144,
    transform: "translate(357.5 414)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_54ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC54ATLabel",
    transform: "translate(410.187 410)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_54ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t54AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC10T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_10T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC10TLine",
    x2: 51,
    transform: "translate(504.5 414)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_10TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC10TLabel",
    transform: "translate(524.668 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_10TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t10T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC010T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_010T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC010TLine",
    x2: 176,
    transform: "translate(558.5 414)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_010TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC010TLabel",
    transform: "translate(612.665 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_010TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t010T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC010T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_010T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC010T1Line",
    x2: 163,
    transform: "translate(737.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_010T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC010T1Label",
    transform: "translate(803.378 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_010T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t010T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC010T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_010T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC010T2Line",
    x2: 149,
    transform: "translate(903.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_010T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC010T2Label",
    transform: "translate(962.378 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_010T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t010T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC67BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_67BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC67BTLine",
    x2: 71,
    transform: "translate(1055.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_67BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC67BTLabel",
    transform: "translate(1031.674 410)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_67BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t67BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC72AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_72AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC72ATLine",
    x2: 236,
    transform: "translate(1129.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_72ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC72ATLabel",
    transform: "translate(1239.187 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_72ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t72AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC16T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_16T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC16TLine",
    x2: 94,
    transform: "translate(1368.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_16TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC16TLabel",
    transform: "translate(1384.238 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_16TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t16T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC16T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_C16T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC16TLine",
    x2: 75,
    transform: "translate(1465.5 414.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_C16TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC16TLabel",
    transform: "translate(1490.198 411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_C16TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC16T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC08T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_08T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC08TLine",
    x2: 183,
    transform: "translate(538.5 478.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_08TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC08TLabel",
    transform: "translate(618.668 474)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_08TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t08T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC05_08T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_05/08T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC05_08TLine",
    x2: 168,
    transform: "translate(724.5 478.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_05/08TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC05_08TLabel",
    transform: "translate(793.359 474)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_05/08TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t05/08T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC05T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_05T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC05TLine",
    x2: 196,
    transform: "translate(895.5 478.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_05TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC05TLabel",
    transform: "translate(988.668 475)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_05TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t05T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC5T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_5T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC5TLine",
    x2: 48,
    transform: "translate(1094.5 478.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_5TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC5TLabel",
    transform: "translate(1112.812 475)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_5TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t5T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC70AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_70AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC70ATLine",
    x2: 220,
    transform: "translate(1145.5 478.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_70ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC70ATLabel",
    transform: "translate(1237.187 474)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_70ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t70AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC51AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_51AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC51ATLine",
    x2: 132,
    transform: "translate(187.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_51ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC51ATLabel",
    transform: "translate(219.186 554)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_51ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t51AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC52AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_52AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC52ATLine",
    x2: 62,
    transform: "translate(323.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_52ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC52ATLabel",
    transform: "translate(328.044 554)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_52ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t52AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC54BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_54BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC54BTLine",
    x2: 111,
    transform: "translate(390.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_54BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC54BTLabel",
    transform: "translate(413.103 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_54BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t54BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC55BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_55BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC55BTLine",
    x2: 78,
    transform: "translate(504.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_55BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC55BTLabel",
    transform: "translate(522.104 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_55BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t55BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC03T3",
    className: "tooltip",
    "edge-id": "BCA_TRACK_03T3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC03T3Line",
    x2: 114,
    transform: "translate(585.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_03T3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC03T3Label",
    transform: "translate(630.523 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_03T3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t03T3\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC03T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_03T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC03T2Line",
    x2: 165,
    transform: "translate(702.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_03T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC03T2Label",
    transform: "translate(753.523 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_03T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t03T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC03T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_03T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC03T1Line",
    x2: 147,
    transform: "translate(870.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_03T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC03T1Label",
    transform: "translate(913.523 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_03T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t03T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC03T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_03T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC03TLine",
    x2: 94,
    transform: "translate(1020.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_03TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC03TLabel",
    transform: "translate(1058.668 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_03TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t03T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3TLine",
    x2: 38,
    transform: "translate(1117.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3TLabel",
    transform: "translate(1130.812 571)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t3T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_3T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3T1Line",
    x2: 64,
    transform: "translate(1158.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_3T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3T1Label",
    transform: "translate(1178.668 555)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_3T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t3T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC71AT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_71AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC71ATLine",
    y1: 1,
    x2: 133,
    transform: "translate(1225.5 557.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_71ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC71ATLabel",
    transform: "translate(1276.187 553)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_71ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t71AT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC013T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_013T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC013TLine",
    x2: 178,
    transform: "translate(1362.5 557.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_013TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC013TLabel",
    transform: "translate(1435.523 553)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_013TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t013T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC02T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_02T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC02TLine",
    y1: 1,
    x2: 222,
    transform: "translate(29.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_02TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC02TLabel",
    transform: "translate(122.668 628)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_02TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t02T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC51BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_51BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC51BTLine",
    x2: 66,
    transform: "translate(254.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_51BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC51BTLabel",
    transform: "translate(285.104 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_51BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t51BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC52BT",
    className: "tooltip",
    "edge-id": "BCA_TRACK_52BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC52BTLine",
    x2: 62,
    transform: "translate(323.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_52BTLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC52BTLabel",
    transform: "translate(342.104 645)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_52BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t52BT\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC4T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_4T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC4T1Line",
    x2: 191,
    transform: "translate(388.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_4T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC4T1Label",
    transform: "translate(476.668 628)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_4T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t4T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC4T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_4T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC4TLine",
    x2: 82,
    transform: "translate(582.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_4TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC4Tlabel",
    transform: "translate(614.812 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_4Tlabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t4T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC04T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_04T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC04TLine",
    x2: 144,
    transform: "translate(667.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_04TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC04TLabel",
    transform: "translate(727.668 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_04TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t04T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC04T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_04T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC04T1Line",
    x2: 149,
    transform: "translate(814.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_04T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC04T1Label",
    transform: "translate(873.523 628)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_04T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t04T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC04T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_04T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC04T2Line",
    x2: 148,
    transform: "translate(966.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_04T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC04T2Label",
    transform: "translate(1021.523 628)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_04T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t04T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC69T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_69T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC69TLine",
    x2: 76,
    transform: "translate(1117.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_69TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC69TLabel",
    transform: "translate(1150.668 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_69TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t69T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC14T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_14T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC14T2Line",
    x2: 105,
    transform: "translate(1196.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_14T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC14T2Label",
    transform: "translate(1236.523 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_14T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t14T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC14T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_14T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC14T1Line",
    x2: 84,
    transform: "translate(1304.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_14T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC14T1Label",
    transform: "translate(1324.523 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_14T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t14T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC14T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_14T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC14TLine",
    x2: 46,
    transform: "translate(1391.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_14TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC14TLabel",
    transform: "translate(1393.382 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_14TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t14T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC14T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_C14T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC14TLine",
    x2: 100,
    transform: "translate(1440.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_C14TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC14TLabel",
    transform: "translate(1460.428 629)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_C14TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC14T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC6T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_6T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC6TLine",
    x2: 201,
    transform: "translate(463.5 686.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_6TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC6TLabel",
    transform: "translate(563.812 683)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_6TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t6T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC06T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_06T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC06TLine",
    x2: 144,
    transform: "translate(667.5 686.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_06TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC06TLabel",
    transform: "translate(716.668 683)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_06TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t06T\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC06T1",
    className: "tooltip",
    "edge-id": "BCA_TRACK_06T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC06T1Line",
    x2: 149,
    transform: "translate(814.5 686.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_06T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC06T1Label",
    transform: "translate(876.523 683)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_06T1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t06T1\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC06T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_06T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC06T2Line",
    x2: 148,
    transform: "translate(966.5 686.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_06T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC06T2Label",
    transform: "translate(1009.523 683)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_06T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t06T2\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TC09T2",
    className: "tooltip",
    "edge-id": "BCA_TRACK_09T2T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TC09T2Label",
    transform: "translate(665.523 222)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_09T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t09T2\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC09T2Line",
    x2: 113,
    transform: "translate(621.5 225.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_09T2TLine"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCC1T",
    className: "tooltip",
    "edge-id": "BCA_TRACK_C1T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCC1TLabel",
    transform: "translate(90.573 554)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_C1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC1T\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TCC1TLine",
    x2: 102,
    transform: "translate(29.5 557.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_C1TLine"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER15Line",
    d: "M316.564-.637h-21.3L26.319,322.268H-7.725",
    transform: "translate(195.5 231.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER14Line",
    d: "M125,0H112.3L11.693,135H-3.317",
    transform: "translate(393.5 418.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER10Line",
    d: "M92.238,0h-10.3L12.283,45.664H2.448",
    transform: "translate(1101.5 636.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER13Line",
    d: "M69.217-1.928h-15.8L13.639,67.87H-.857",
    transform: "translate(486.633 485.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER12Line",
    d: "M55.11,0H44.556L5.055,64.419H-6.631",
    transform: "translate(330.5 563.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER08Line",
    d: "M10.411,0H28.363L72.8,69H86.746",
    transform: "translate(1135.5 484.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER09ine",
    d: "M-11.635,0H4.484L67.738,63.454H80.5",
    transform: "translate(1237.5 563.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER04Line",
    d: "M265.948-3.21l-26.959.361L13.732,173.943H-15.11",
    transform: "translate(1144.5 234.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER11Line",
    d: "M-5.7-.982H8.77L60.719,43.456H75.836",
    transform: "translate(588.5 638.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER06Line",
    d: "M0,0H11.35L46.9,60H60.666",
    transform: "translate(1048.5 348.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER07Line",
    d: "M41.193-.756H30.66L5.482,53.078h-11.6",
    transform: "translate(1100.5 420.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER05Line",
    d: "M-3.7,60.2H4.018L51.6,0h8.721",
    transform: "translate(508.5 348.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER03Line",
    d: "M17.745,47.939H30.16L63.2,1.16H74.9",
    transform: "translate(1131.5 229.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER02Line",
    d: "M-6.6,0H7.168L53.141,47.423H64.293",
    transform: "translate(549.5 230.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER16Line",
    d: "M-8.109-1.378H7.6l52.109,64.7H73.772",
    transform: "translate(195.5 564.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC125AXT",
    transform: "translate(431.743 219.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTLine",
    d: "M0,0H32.646l4.189-3.253",
    transform: "translate(4 6)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES",
    y1: 10,
    transform: "translate(4 1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-2",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(4 1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC1T",
    transform: "translate(53)",
    className: "tooltip",
    "edge-id": "BCA_TRACK_1T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TC1TLabel",
    transform: "translate(95.573 554)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_TRACK_1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t1T\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("line", {
    id: "TC1TLine",
    x2: 49,
    transform: "translate(82.5 557.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "BCA_TRACK_1TLine"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM51A",
    transform: "translate(193.207 548.381)",
    className: "tooltip",
    "edge-id": "BCA_PM_51A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM51AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -14.554, 20.266)",
    "edge-id-selector": "BCA_PM_51AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM51AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_51AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM51AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_51AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM51AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_51AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM51ALabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_51ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t51A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM51B",
    transform: "translate(250.801 585.563)",
    className: "tooltip",
    "edge-id": "BCA_PM_51B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM51BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 26.266)",
    "edge-id-selector": "BCA_PM_51BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM51BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_51BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM51BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_51BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM51BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_51BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM51BLabel",
    transform: "translate(-1.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_51BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t51B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM53B",
    transform: "translate(194.391 511.179)",
    className: "tooltip",
    "edge-id": "BCA_PM_53B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM53BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_53BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM53BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_53BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM53BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_53BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM53BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_53BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM53BLabel",
    transform: "translate(-1.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_53BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t53B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM53A",
    transform: "translate(494.09 215.44)",
    className: "tooltip",
    "edge-id": "BCA_PM_53A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM53AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_53AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM53AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_53AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM53AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_53AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM53AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_53AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM53ALabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_53ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t53A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM54B",
    transform: "translate(388.151 511.563)",
    className: "tooltip",
    "edge-id": "BCA_PM_54B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM54BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_54BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM54BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_54BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM54BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_54BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM54BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_54BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM54BLabel",
    transform: "translate(-1.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_54BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t54B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM54A",
    transform: "translate(510.72 403.35)",
    className: "tooltip",
    "edge-id": "BCA_PM_54A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM54AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_54AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM54AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_54AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM54AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_54AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM54AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_54AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM54ALabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_54ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t54A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM55B",
    transform: "translate(482.72 511.563)",
    className: "tooltip",
    "edge-id": "BCA_PM_55B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM55BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_55BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM55BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_55BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM55BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_55BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM55BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_55BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM55BLabel",
    transform: "translate(-1.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_55BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t55B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM55A",
    transform: "translate(544.329 467.854)",
    className: "tooltip",
    "edge-id": "BCA_PM_55A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM55AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_55AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM55AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_55AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM55AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_55AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM55AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_55AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM55ALabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_55ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t55A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM52B",
    transform: "translate(318.72 585.563)",
    className: "tooltip",
    "edge-id": "BCA_PM_52B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM52BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_52BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM52BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_52BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM52BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_52BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM52BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_52BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM52BLabel",
    transform: "translate(-1.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_52BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t52B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM52A",
    transform: "translate(377.878 548.809)",
    className: "tooltip",
    "edge-id": "BCA_PM_52A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM52AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_52AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM52AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_52AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM52AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_52AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM52AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_52AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM52ALabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_52ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t52A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM57A",
    transform: "translate(645.466 640.23)",
    className: "tooltip",
    "edge-id": "BCA_PM_57A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM57AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 25.139)",
    "edge-id-selector": "BCA_PM_57AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM57AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_57AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM57AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_57AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM57AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_57AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM57ALabel",
    transform: "translate(-2.518 23.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_57ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t57A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM57B",
    transform: "translate(579.866 616.477)",
    className: "tooltip",
    "edge-id": "BCA_PM_57B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM57BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -6.722, 25.519)",
    "edge-id-selector": "BCA_PM_57BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM57BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_57BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM57BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_57BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM57BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_57BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM57BLabel",
    transform: "translate(-0.018 47.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_57BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t57B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM69B",
    transform: "translate(1185.383 621.564)",
    className: "tooltip",
    "edge-id": "BCA_PM_69B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM69BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_69BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM69BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_69BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM69BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_69BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM69BIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_69BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM69BLabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_69BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t69B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM69A",
    transform: "translate(1097.132 639.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_69A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM69AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_69AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM69AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_69AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM69AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_69AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM69AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_69AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM69ALabel",
    transform: "translate(-6.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_69ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t69A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM59B",
    transform: "translate(540.052 209.44)",
    className: "tooltip",
    "edge-id": "BCA_PM_59B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM59BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -6.722, 25.519)",
    "edge-id-selector": "BCA_PM_59BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM59BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_59BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM59BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_59BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM59BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_59BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM59BLabel",
    transform: "translate(-1.018 48.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_59BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t59B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM65B",
    transform: "translate(1197.925 215.687)",
    className: "tooltip",
    "edge-id": "BCA_PM_65B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM65BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_65BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM65BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_65BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM65BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_65BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM65BIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_65BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM65BLabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_65BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t65B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM65A",
    transform: "translate(1144.466 234.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_65A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM65AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_65AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM65AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_65AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM65AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_65AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM65AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_65AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM65ALabel",
    transform: "translate(-5.518 23.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_65ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t65A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM72A",
    transform: "translate(1136.573 365.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_72A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM72AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_72AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM72AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_72AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM72AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_72AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM72AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_72AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM72ALabel",
    transform: "translate(-6.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_72ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t72A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM72B",
    transform: "translate(1391.925 221.064)",
    className: "tooltip",
    "edge-id": "BCA_PM_72B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM72BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 13.778, 15.893)",
    "edge-id-selector": "BCA_PM_72BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM72BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_72BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM72BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_72BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM72BIcon",
    transform: "translate(-1.018 13.773)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_72BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM72BLabel",
    transform: "translate(-7.35 37.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_72BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t72B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM58A",
    transform: "translate(562.09 333.701)",
    className: "tooltip",
    "edge-id": "BCA_PM_58A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM58AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_58AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM58AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_58AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM58AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_58AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM58AIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_58AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM58ALabel",
    transform: "translate(-7.35 41.02)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_58ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t58A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM71A",
    transform: "translate(1225.716 541.738)",
    className: "tooltip",
    "edge-id": "BCA_PM_71A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM71Hr",
    transform: "matrix(1, -0.005, 0.005, 1, -6.722, 25.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM71AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_71AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM71AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_71AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM71AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_71AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM71ALabel",
    transform: "translate(-1.018 48.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_71ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t71A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM71B",
    transform: "translate(1300.466 584.491)",
    className: "tooltip",
    "edge-id": "BCA_PM_71B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM71BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 25.139)",
    "edge-id-selector": "BCA_PM_71BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM71BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_71BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM71BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_71BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM71BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_71BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM71BLabel",
    transform: "translate(-2.518 20.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_71BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t71B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM70B",
    transform: "translate(1204.634 510.854)",
    className: "tooltip",
    "edge-id": "BCA_PM_70B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM70BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 25.139)",
    "edge-id-selector": "BCA_PM_70BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM70BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_70BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM70Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM70BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_70BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM70BLabel",
    transform: "translate(0.482 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_70BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t70B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM70A",
    transform: "translate(1144.716 463.1)",
    className: "tooltip",
    "edge-id": "BCA_PM_70A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM70AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -6.722, 25.519)",
    "edge-id-selector": "BCA_PM_70AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM70AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_70AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM70AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_70AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM70AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_70AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM70ALabel",
    transform: "translate(1.982 47.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_70ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t70A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM66A",
    transform: "translate(1043.052 327.223)",
    className: "tooltip",
    "edge-id": "BCA_PM_66A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM66AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -6.722, 25.519)",
    "edge-id-selector": "BCA_PM_66AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM66AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_66AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM66AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_66AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM66AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_66AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM66ALabel",
    transform: "translate(1.982 47.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_66ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t66A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM67B",
    transform: "translate(1134.383 404.564)",
    className: "tooltip",
    "edge-id": "BCA_PM_67B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM67BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 12.446, 20.266)",
    "edge-id-selector": "BCA_PM_67BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM67BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_67BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM67BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_67BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM67BIcon",
    transform: "translate(-4.018 18.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_67BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM67BLabel",
    transform: "translate(-8.518 41.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_67BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t67B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM59A",
    transform: "translate(596.466 236.44)",
    className: "tooltip",
    "edge-id": "BCA_PM_59A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM59AHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 25.139)",
    "edge-id-selector": "BCA_PM_59AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM59AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_59AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM59AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_59AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM59AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_59AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM59ALabel",
    transform: "translate(-2.518 21.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_59ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t59A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM67A",
    transform: "translate(1089.132 430.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_67A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM67AHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_67AHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM67AHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_67AHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM67AHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_67AHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM67AIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_67AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM67ALabel",
    transform: "translate(-6.518 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_67ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t67A\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM66B",
    transform: "translate(1091.466 365.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_66B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM66BHr",
    transform: "matrix(1, -0.005, 0.005, 1, 19.278, 25.139)",
    "edge-id-selector": "BCA_PM_66BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM66BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_66BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM66BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_66BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM66BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_66BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM66BLabel",
    transform: "translate(-0.518 23.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_66BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t66B\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM58B",
    transform: "translate(497.151 366.94)",
    className: "tooltip",
    "edge-id": "BCA_PM_58B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM58BHr",
    transform: "matrix(1, -0.005, 0.005, 1, -7.388, 26.266)",
    "edge-id-selector": "BCA_PM_58BHr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM58BHr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)",
    "edge-id-selector": "BCA_PM_58BHr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM58BHr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "BCA_PM_58BHr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM58BIcon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "BCA_PM_58BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM58BLabel",
    transform: "translate(0.482 23.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_PM_58BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t58B\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "Poles"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC12TPOLES",
    y1: 10,
    transform: "translate(446.743 338.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC54ATPOLES",
    y1: 10,
    transform: "translate(357.743 409.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC015TPOLES",
    y1: 10,
    transform: "translate(1583.5 220.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TCC16TPOLES",
    y1: 10,
    transform: "translate(1540.5 409.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC70ATPOLES",
    y1: 10,
    transform: "translate(1364.5 473.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC013TPOLES",
    y1: 10,
    transform: "translate(1540.5 552.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TCC-14TPOLES",
    y1: 10,
    transform: "translate(1540.5 627.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TCC-1TPOLES",
    y1: 10,
    transform: "translate(29.617 553.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC6TPOLES",
    y1: 10,
    transform: "translate(463.617 681.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC02TPOLES",
    y1: 10,
    transform: "translate(29.5 628.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC012T2POLES",
    y1: 10,
    transform: "translate(1099.5 339.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Signal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS8",
    transform: "matrix(1, -0.005, 0.005, 1, 563.64, 478.886)",
    className: "tooltip",
    "edge-id": "BCA_SG_S8"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS8Label",
    transform: "translate(5.76 34.104)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S8Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-8\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS8Aspect2",
    transform: "translate(-1 6.954)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S8Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS8Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S8Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES",
    transform: "translate(30.19 0.626)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS13",
    transform: "matrix(-1, 0.005, -0.005, -1, 1529.691, 556.97)",
    className: "tooltip",
    "edge-id": "BCA_SG_S13"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS13Label",
    transform: "translate(49.92 25) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S13Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-13\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS13Aspect2",
    transform: "translate(22.078 6.926)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S13Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS13Aspect1",
    transform: "translate(37.156 7.004)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S13Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(51.42)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-2",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC14",
    transform: "matrix(1, -0.005, 0.005, 1, 1403.755, 633.335)",
    className: "tooltip",
    "edge-id": "BCA_SG_C14"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC14Label",
    transform: "translate(27.92 32.666)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_C14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC-14\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGC14Aspect",
    transform: "translate(26.96 10.566)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_C14Aspect"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(2.25 -0.988)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-3",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(39.283 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    x2: 5,
    transform: "translate(34.283 16.439)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3",
    x2: 2,
    transform: "translate(22.698 16.353)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS14",
    transform: "matrix(1, -0.005, 0.005, 1, 1398.427, 633.911)",
    className: "tooltip",
    "edge-id": "BCA_SG_S14"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS14Label",
    transform: "translate(5.76 33.959)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-14\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S14Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S14Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS16",
    transform: "matrix(1, -0.005, 0.005, 1, 1432.427, 416.911)",
    className: "tooltip",
    "edge-id": "BCA_SG_S16"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS16Label",
    transform: "translate(5.76 33.959)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-16\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S16Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S16Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS4",
    transform: "matrix(1, -0.005, 0.005, 1, 746.788, 632.765)",
    className: "tooltip",
    "edge-id": "BCA_SG_S4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS4Label",
    transform: "translate(5.76 34.104)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S4Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-4\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS4Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S4Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS4Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S4Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-5",
    "data-name": "POLES",
    transform: "translate(30.19 0.626)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC16",
    transform: "matrix(1, -0.005, 0.005, 1, 1436.755, 416.335)",
    className: "tooltip",
    "edge-id": "BCA_SG_C16"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC16Label",
    transform: "translate(27.92 32.666)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_C16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC-16\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGC16Aspect",
    transform: "translate(26.96 10.566)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_C16Aspect"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-6",
    "data-name": "POLES",
    transform: "translate(2.25 -0.988)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-5",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(39.283 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-5",
    "data-name": "POLES2",
    x2: 5,
    transform: "translate(34.283 16.439)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-2",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(22.698 16.353)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS12",
    transform: "matrix(1, -0.005, 0.005, 1, 586.14, 343.886)",
    className: "tooltip",
    "edge-id": "BCA_SG_S12"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS12Label",
    transform: "translate(5.76 34.104)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S12Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-12\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S12Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S12Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-7",
    "data-name": "POLES",
    transform: "translate(30.19 0.626)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-6",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-6",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS10",
    transform: "matrix(1, -0.005, 0.005, 1, 547.788, 413.886)",
    className: "tooltip",
    "edge-id": "BCA_SG_S10"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS10Label",
    transform: "translate(5.76 34.104)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S10Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-10\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS10Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S10Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS10Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S10Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-8",
    "data-name": "POLES",
    transform: "translate(30.19 0.626)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-7",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-7",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS15",
    transform: "matrix(-1, 0.005, -0.005, -1, 1578.011, 226.205)",
    className: "tooltip",
    "edge-id": "BCA_SG_S15"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS15Label",
    transform: "translate(49.92 25) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S15Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-15\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS15pect2",
    transform: "translate(22.078 6.926)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S15pect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS15Aspect1",
    transform: "translate(37.156 7.004)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S15Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-9",
    "data-name": "POLES",
    transform: "translate(51.42)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-8",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-8",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS7",
    transform: "matrix(1, -0.005, 0.005, 1, 1074.427, 253.911)",
    className: "tooltip",
    "edge-id": "BCA_SG_S7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS7Label",
    transform: "translate(7.907 5.97)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S7Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-7\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS7Aspect1",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S7Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS7Aspect2",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S7Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS3",
    transform: "matrix(1, -0.005, 0.005, 1, 1123.427, 527.911)",
    className: "tooltip",
    "edge-id": "BCA_SG_S3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS3Label",
    transform: "translate(7.907 5.97)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-3\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S3Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S3Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS5",
    transform: "matrix(1, -0.005, 0.005, 1, 1052.427, 448.911)",
    className: "tooltip",
    "edge-id": "BCA_SG_S5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS5Label",
    transform: "translate(7.907 5.97)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S5Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-5\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS5Aspect1",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S5Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS5Aspect2",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S5Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS6",
    transform: "matrix(1, -0.005, 0.005, 1, 747.427, 683.575)",
    className: "tooltip",
    "edge-id": "BCA_SG_S6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS6Label",
    transform: "translate(8.75 35.975)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S6Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-6\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS6Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S6Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS6Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S6Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS9",
    transform: "matrix(1, -0.005, 0.005, 1, 1195.427, 196.509)",
    className: "tooltip",
    "edge-id": "BCA_SG_S9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS9Label",
    transform: "translate(8.912 4.975)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_S9Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tS-9\n\t\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "SGS9Aspect1",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S9Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS9Aspect2",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "BCA_SG_S9Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Shunt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SH203",
    transform: "translate(520.036 185.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -11.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH203Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH203Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-203\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 13.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH203Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 27.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH203Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH203Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH203Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH203Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH203Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH202",
    transform: "translate(1319.166 550.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-2",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH202Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH202Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-202\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH202Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH202Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH202Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH202Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH202Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH202Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH212",
    transform: "translate(611.166 218.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-3",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole1-2",
    "data-name": "SH212Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "BCA_SG_SH212Pole1-2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole2-2",
    "data-name": "SH212Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "BCA_SG_SH212Pole2-2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH212Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH212Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-212\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-2",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH212Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH212Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH212Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH212Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH212Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH212Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH210",
    transform: "translate(596.166 274.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-4",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH210Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "BCA_SG_SH210Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH210Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "BCA_SG_SH210Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH210Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH210Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-210\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-3",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH210Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH210Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH210Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH210Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH210Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH210Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH106",
    transform: "translate(758.166 678.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-5",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole1-3",
    "data-name": "SH212Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole2-3",
    "data-name": "SH212Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH106Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH106Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-106\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-4",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH106Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH106Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH106Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH106Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH106Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH106Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH105",
    transform: "translate(1021.036 439.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-6",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-2",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-2",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH105Label",
    transform: "translate(-2.5 8)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH105Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-105\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-2",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH105Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH105Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH105Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH105Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH105Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH105Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH207",
    transform: "translate(1003.036 375.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-7",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-3",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-3",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH207Label",
    transform: "translate(1.5 8)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH207Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-207\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-3",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH207Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH207Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH207Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH207Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH207Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH207Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH209",
    transform: "translate(1062.036 305.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-8",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-4",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-4",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH209Label",
    transform: "translate(1.5 8)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH209Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-209\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-4",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH209Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH209Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH209Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH209Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH209Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH209Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH107",
    transform: "translate(1044.036 243.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-9",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-5",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-5",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH107Label",
    transform: "translate(-11.5 10)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH107Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-107\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-5",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH107Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH107Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH107Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH107Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH107Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH107Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH103",
    transform: "translate(1091.036 517.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-10",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-6",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-6",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH103Label",
    transform: "translate(1.5 8)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH103Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-103\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-6",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH103Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH103Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH103Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH103Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH103Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH103Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH109",
    transform: "translate(1165.036 185.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-11",
    "data-name": "Pole",
    transform: "translate(5.964 30.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-7",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -12.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-7",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 -2.777) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH109Label",
    transform: "translate(-10.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH109Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-109\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-7",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 10.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH109Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH109Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH109Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 18.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH109Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH109Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH109Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH201",
    transform: "translate(167.036 593.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-12",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-8",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -11.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-8",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH201Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH201Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-201\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-8",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 13.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH201Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 27.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH201Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH201Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH201Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH201Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH201Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH205",
    transform: "translate(496.036 646.062)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-13",
    "data-name": "Pole",
    transform: "translate(5.964 29.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-9",
    "data-name": "SH7Pole1",
    y1: 21.44,
    transform: "translate(0 -11.058)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole2-9",
    "data-name": "SH7Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH205Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH205Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-205\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-9",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.565 13.401)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH205spect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 27.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH205spect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH205Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14 21.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH205Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH205Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22 24.378) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH205Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH206",
    transform: "translate(1220.166 471.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-14",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole1-4",
    "data-name": "SH212Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH212Pole2-4",
    "data-name": "SH212Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH206Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH206Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-206\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-5",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH206Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH206Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH206Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH206Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH206Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH206Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH208",
    transform: "translate(526.166 551.56)",
    className: "tooltip",
    "edge-id": "BCA_SG_SH208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-15",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH210Pole1-2",
    "data-name": "SH210Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH210Pole2-2",
    "data-name": "SH210Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH208Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "BCA_SG_SH208Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tSH-208\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-6",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH208Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH208Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH208Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH208Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH208Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.286)",
    "edge-id-selector": "BCA_SG_SH208Aspect1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(-93.45 466.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend",
    transform: "translate(1181 -730.028)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(227 974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tPOINT MACHINE\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(227 979.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    transform: "translate(0 0.232)",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(32 16.232)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tNORMAL\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(227 1003.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    transform: "translate(0 0.416)",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(30 15.416)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tREVERSE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(227.929 1024.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M10.433,19.646C4.823,15.724,1.881,12.155.675,9.168c-3.232-8,6-11.832,9.758-7.107,3.758-4.725,12.991-.9,9.758,7.107C18.985,12.155,16.043,15.724,10.433,19.646Z",
    transform: "translate(0 3.457)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094.01H5.175L7.357-3.307l2.832,6.271L12.232.01,19.327,0",
    transform: "translate(0.807 12.769)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(28.702 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    transform: "translate(216 955)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 124,
    height: 107,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(702 -788.03)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(898 1032)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tTRACK CIRCUIT\n\t\t\t\t\t\t")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(888.5 1040.52)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 70,
    transform: "translate(-2 10.474)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(75.5 15.974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFREE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(897.5 1061.093)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 70,
    transform: "translate(-11 12.846)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(65.921 18.346)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tOCCUPIED\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(897.5 1083.744)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 70,
    transform: "translate(-11 11.296)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(68 16.796)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tFAILURE\n\t\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    transform: "translate(876 1013)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 157,
    height: 107,
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcaStation);
export default __webpack_public_path__ + "static/media/BCA_Station.dd72a56d1d166e2c254b255973c1ea5a.svg";
export { ForwardRef as ReactComponent };